// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCzSRTDCUqGFFh6sR_yND4rpKe8LLa4Fls",
  authDomain: "don-tcryai.firebaseapp.com",
  projectId: "don-tcryai",
  storageBucket: "don-tcryai.firebasestorage.app",
  messagingSenderId: "785092227584",
  appId: "1:785092227584:web:5821a830e476a030a01ee5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);